<template>
    <div class="full-w full-h" v-loading="submitLoading"></div>
</template>

<script>

    import API from '@/api/home';
    import {setIsLogin} from '../utils/auth';
    import {mapState} from 'vuex';
    import {asyncRoutes} from '../router';

    export default {
        name: "AUC",
        data(){
            return{
                submitLoading:false,
                ssoCode:'',
            }
        },
        created(){
            this.ssoCode = this.$route.query.sso_authorize_code;
            this.getAUC();
        },
        computed:{
            ...mapState({
                pageConfig:state => state.user.page_config,
            }),
        },
        methods:{
            getAUC(){
                if(!this.ssoCode) return this.$message.error('参数有误');

                this.submitLoading = true;
                let res_sso = ''
                if(Array.isArray(this.ssoCode) && this.ssoCode.length>0) {
                    res_sso = this.ssoCode[this.ssoCode.length-1]
                }else{
                    res_sso = this.ssoCode;
                }
                API.getAUC({
                    sso_authorize_code:res_sso
                }).then(async res => {
                    this.$message.success(res.info || '操作成功');
                    localStorage.setItem("needLoginSuccessModal",'true');
                    setIsLogin(true);
                  
                    
                    let defaultConfig  = await this.getUserPageConfig();
                    let defaultPage = defaultConfig.default_page||'';
                    let defaultRoute  = this._findFieldByName(asyncRoutes,defaultPage)
                    let dataQueryAnalysisDefaultPlat = defaultConfig.data_query_analysis_default_plat||'';
                    if(defaultPage) {
                        if(defaultRoute.name=='data_query_analysis'&&dataQueryAnalysisDefaultPlat){
                            this.$router.push({path: defaultRoute.path+'/'+dataQueryAnalysisDefaultPlat});
                        }else{
                            this.$router.push({path: defaultRoute.path});
                        }
                    }else{
                        this.$router.push({path: '/home'});
                    }
                    this.submitLoading = false;
                }, (err) => {
                    console.log('bindWeiXin error', err);
                    this.$message.error(err.info || '操作失败');

                    let errData = err.data||{};
                    let login_url = errData.login_url;
                    if(login_url){
                        window.location.href = login_url;
                    }
                    this.submitLoading = false;
                });
            },
            async getUserPageConfig(){
                const {data} = await API.getUserPageConfig();
                return data||{};
            },
            _findFieldByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
        }

    }
</script>

<style scoped lang="scss">
    .bind-form{
        margin: 20px 50px;
    }
    ::v-deep .el-input__inner {
        border-radius: 23px;
        height: 45px;
    }

    .bind-result{
        position: absolute;
        width: 100%;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background-color: #f7f8fa;
    }

    .icon{
        font-size: 70px;
    }

</style>
